import { SECTION_STATUS_MAP } from "@shared/components/form-builder/utils/constants";
import { FORM_SECTION_STATUS_KEY } from "./constants";

export const checkAllEntityFormsSubmitted = (formList) => {
  if (!formList || !Array.isArray(formList) || !formList.length) {
    // if no forms, then all are submitted:
    return true;
  }
  return formList.every((el) => el?.isSubmitted);
};

export const submitAllEntityForms = (formList) => {
  if (!formList || !Array.isArray(formList) || !formList.length) {
    return;
  }
  // submit all entity forms:
  Object.values(formList).forEach((el) => {
    if (el && !el.isSubmitted) {
      el.submit();
    }
  });
};

export const checkFormCompleted = (entityForm) => {
	const sections = entityForm?.sections || [];
	if (!sections?.length) return false;

	return sections.every((section) => {
		return section[FORM_SECTION_STATUS_KEY] === SECTION_STATUS_MAP.COMPLETED;
	});
}